module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "termsAccepted"
    },
    on: {
      "change": _vm.setTermsAccepted
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("By participating in the sale, you agree to its "), _c('a', {
    staticClass: "aragon underline",
    attrs: {
      "href": "/static/terms.pdf"
    }
  }, [_vm._v("terms and conditions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51c635a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Disclaimer.vue
// module id = 512
// module chunks = 1